import RouteConfig from './RouteConfig';
import PageConfig from '../core/PageConfig';

// Layouts
import UserLayout from 'src/layouts/UserLayout';

/* Pages */
import HomePage from 'src/pages/HomePage';
import StyleGuide from 'src/pages/0Dev/StyleGuide';

class NavigationPages {
  public MyPages: PageConfig[] = [
    // Core Pages
    { key: 'home', route: RouteConfig.LINK.HOME, publicLayout: UserLayout, publicComponent: HomePage },

    // Development Pages
    { key: 'style-guide', route: RouteConfig.LINK.STYLE_GUIDE, publicLayout: UserLayout, publicComponent: StyleGuide },
  ];
}

const Pages = new NavigationPages();
export default Pages;
